import React from 'react';
import { StyledSwatch, StyledSwatchFrame, ColorSwatchContainer, ColorSwatchContent, StyledArrowButton, styles } from './SwatchColorCarouselStyles';
import { useSwatchColorCarousel } from './useSwatchColorCarousel';
import { SwatchColorCarouselProps } from './types';
import { Box, BoxProps, Flex, IconV1 } from '@withjoy/joykit';

const PrimaryControlArrow: React.FC<BoxProps & { $dir: 'left' | 'right' }> = props => {
  return (
    <StyledArrowButton
      __css={styles.arrowButton}
      {...props}
    />
  );
};

export const SwatchColorCarousel: React.FC<SwatchColorCarouselProps> = (props: SwatchColorCarouselProps) => {
  const {
    optionsToRender,
    colorSelected,
    handleMouseClick,
    handleMouseOver,
    handleMouseOut,
    swatchSize,
    nextPos,
    pageRef,
    containerRef,
    handleArrowClick,
    showLeftArrow,
    showRightArrow,
    rootWidth,
  } = useSwatchColorCarousel(props);
  const { checkAvailability = false } = props;

  return (
    <Box
      __css={styles.colorCarousel}
      ref={pageRef}
    >
      <Flex
        __css={styles.colorCarouselContainer}
        ref={containerRef}
        width={rootWidth}
      >
        {showLeftArrow && (
          <PrimaryControlArrow
            $dir="left"
            style={{ left: 0 }}
          >
            <Box
              as="button"
              onClick={() => handleArrowClick('left')}
            >
              <IconV1
                source="chevronLeft"
                iconSize={swatchSize}
              />
            </Box>
          </PrimaryControlArrow>
        )}
        <ColorSwatchContainer
          __css={styles.colorSwatchContainer}
          $nextPos={nextPos}
          width="100%"
        >
          {optionsToRender.map((option, index) => {
            return (
              (option.color || option.imageUrl) && (
                <Box
                  key={option.id}
                  __css={styles.swatchFrame}
                >
                  <ColorSwatchContent __css={styles.colorSwatchContent}>
                    <StyledSwatchFrame
                      as="button"
                      onClick={(e: React.MouseEvent) => handleMouseClick(e, option)}
                      onMouseOver={(e: React.MouseEvent) => handleMouseOver(e, option)}
                      onMouseOut={(e: React.MouseEvent) => handleMouseOut(e, option)}
                      aria-label={option.label}
                      __css={styles.colorSwatchContentOver}
                    >
                      <StyledSwatch
                        aria-label={option.label}
                        __css={styles.swatch}
                        _after={{
                          opacity: colorSelected === option.id ? 1 : 0,
                        }}
                        data-readonly={(checkAvailability && option.notAvailable) || undefined}
                        size={swatchSize}
                        style={{ backgroundColor: option.color || undefined, backgroundImage: option.imageUrl ? `url(${option.imageUrl})` : undefined }}
                      />
                    </StyledSwatchFrame>
                  </ColorSwatchContent>
                </Box>
              )
            );
          })}
        </ColorSwatchContainer>
        {showRightArrow && (
          <PrimaryControlArrow
            $dir="right"
            style={{ right: 0 }}
          >
            <Box
              as="button"
              onClick={() => handleArrowClick('right')}
            >
              <IconV1
                source="chevronRight"
                iconSize={swatchSize}
              />
            </Box>
          </PrimaryControlArrow>
        )}
      </Flex>
    </Box>
  );
};
